import React, { useState } from "react";
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { CustomForm, CustomInput, CustomSelect } from '../../../../fgs';
import { userValidations, userValidationMessages } from '../../../validations';
import { Visible, canPerform } from "../../../../fgs/helpers/Authorization";

import { userRoleOptions } from "../../../../services/selectOptions";

const ProfileForm = (props) => {
  const history = useHistory();
  const { id } = useParams();
  const { form, onSave, setShowForm } = props;

  const [updateForm, setUpdateForm] = useState({
    accessId: form.accessId || '',
    email: form.email || '',
    name: form.name || '',
    role: form. role || '',
    additionalInformationAttributes: { 
      instrumentation_url: form.instrumentationUrl
    } || {}
  });

  const onSelectChange = (name, selected) => {
    const selectedValue = selected ? selected : {};
    const newForm = Object.assign({}, updateForm);
    newForm[name] = selectedValue.value;

    setUpdateForm(newForm);
  };

  const onChange = (e) => {
    const newForm = Object.assign({}, updateForm);

    if (e.target.name === 'instrumentationUrl') {
      newForm.additionalInformationAttributes = { instrumentation_url: e.target.value };
    } else {
      newForm[e.target.name] = e.target.value;
    }


    setUpdateForm(newForm);
  };

  const validations = () => {
    const profileValidations = Object.assign({}, userValidations);
    profileValidations.password = () => true;

    return profileValidations;
  };

  const formControls = [
    { title: 'Salvar', props: { type: 'submit', color: 'primary' } },
    { 
      title: 'Alterar Senha', 
      props: { 
        type: 'submit', 
        color: 'danger',
        onClick: () => history.push(`/dashboard/alter-password/${id}`)
      }
    },
    { title: 'Modo Leitura', props: { onClick: setShowForm, color: 'secondary' } }
  ];

  return (
    <CustomForm
      validationMessages={userValidationMessages}
      validations={validations()}
      form={updateForm}
      formControls={formControls}
      onSubmit={() => onSave(updateForm)}>
      <Row>
        <Col xs="6">
          <CustomInput
            labelText="Nome"
            hasIcon={true}
            iconName="User"
            iconPosition="prepend"
            inputName="name"
            onChange={onChange}
            inputValue={updateForm.name} />
        </Col>

        <Col xs="6">
          <CustomInput
            labelText="Login ID"
            hasIcon={true}
            iconName="Key"
            iconPosition="prepend"
            inputName="accessId"
            placeholder="john_doe"
            onChange={onChange}
            inputValue={updateForm.accessId} />
        </Col>
      </Row>

      <Row>
        <Col xs="8">
          <CustomInput
            labelText="E-mail"
            hasIcon={true}
            iconName="Mail"
            iconPosition="prepend"
            inputName="email"
            placeholder="john_doe@fgsgeotecnia.com"
            inputType="email"
            onChange={onChange}
            inputValue={updateForm.email} />
        </Col>

        <Col xs="4">
          <Visible when={canPerform('UserProfilePage', 'update_sensible_information')}>
            <CustomSelect
              labelText="Função"
              inputName="role"
              options={userRoleOptions}
              onChange={onSelectChange}
              selected={updateForm.role} />
          </Visible>
        </Col>
      </Row>

      <Row>
        <Col xs="12">
          <Visible when={canPerform('UserProfilePage', 'update_sensible_information')}>
            <CustomInput
              labelText="URL Instrumentação"
              hasIcon={true}
              iconName="Link"
              iconPosition="prepend"
              inputName="instrumentationUrl"
              placeholder="https://..."
              onChange={onChange}
              inputValue={updateForm.additionalInformationAttributes?.instrumentation_url} />
          </Visible>
        </Col>
      </Row>
    </CustomForm>
  );
};

ProfileForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  setShowForm: PropTypes.func.isRequired
};

export default ProfileForm;